module.exports = __webpack_public_path__ + "media/images/gift/steps/friend-913902001ec792cb08fb377c9e5c9df5.png";